__webpack_require__.p = "/fragments/footer/legacy/";